"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageVariantElementsBuilder = exports.LanguageVariantElementsBuilder = void 0;
var LanguageVariantElementsBuilder = /** @class */ (function () {
    function LanguageVariantElementsBuilder() {
    }
    LanguageVariantElementsBuilder.prototype.assetElement = function (element) {
        return element;
    };
    LanguageVariantElementsBuilder.prototype.customElement = function (element) {
        return element;
    };
    LanguageVariantElementsBuilder.prototype.dateTimeElement = function (element) {
        return element;
    };
    LanguageVariantElementsBuilder.prototype.linkedItemsElement = function (element) {
        return element;
    };
    LanguageVariantElementsBuilder.prototype.multipleChoiceElement = function (element) {
        return element;
    };
    LanguageVariantElementsBuilder.prototype.numberElement = function (element) {
        return element;
    };
    LanguageVariantElementsBuilder.prototype.richTextElement = function (element) {
        return element;
    };
    LanguageVariantElementsBuilder.prototype.taxonomyElement = function (element) {
        return element;
    };
    LanguageVariantElementsBuilder.prototype.textElement = function (element) {
        return element;
    };
    LanguageVariantElementsBuilder.prototype.urlSlugElement = function (element) {
        return element;
    };
    LanguageVariantElementsBuilder.prototype.any = function (element) {
        return element;
    };
    return LanguageVariantElementsBuilder;
}());
exports.LanguageVariantElementsBuilder = LanguageVariantElementsBuilder;
exports.languageVariantElementsBuilder = new LanguageVariantElementsBuilder();
//# sourceMappingURL=language-variant-elements-builder.js.map